var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import MUIDataTable from 'mui-datatables';
import * as Papa from "papaparse";
import { CircularProgress, Box } from '@mui/material';
var CSVPreview = function (props) {
    var _a = useState([]), rows = _a[0], setRows = _a[1];
    var _b = useState([]), columns = _b[0], setColumns = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    useEffect(function () {
        Papa.parse(props.url, {
            header: false,
            download: true,
            complete: function (results) {
                var rows = [];
                results.data.forEach(function (row, index) {
                    if (index === 0 && props.headers) {
                        setColumns(__spreadArray([], row, true));
                    }
                    else {
                        rows.push(row);
                    }
                });
                if (!props.headers && columns.length === 0) {
                    setColumns(__spreadArray([], rows[0], true));
                }
                setRows(__spreadArray([], rows, true));
                setLoading(false);
            },
        });
    }, []);
    return (_jsx(Box, { children: loading ? _jsx(CircularProgress, {}) : _jsx(MUIDataTable, { title: '', data: rows, columns: columns, options: {
                download: false,
                print: false,
                filter: false,
                viewColumns: false,
                pagination: false,
                search: false,
                selectableRowsHeader: false,
                selectableRowsHideCheckboxes: true,
                selectableRowsOnClick: false,
                selectableRows: 'none',
            } }) }));
};
export default CSVPreview;
